import React, { ReactNode, useEffect, useState } from 'react';
import { MultiTenantContext } from './MultiTenantContext';

export const getMultiTenantContextInitialState = (): {
    tenantId: string;
    tenantName: string;
    datavanter: boolean;
} => {
    const multiTenant = typeof window !== 'undefined' && window.localStorage.getItem('multiTenant');
    return multiTenant ? JSON.parse(multiTenant) : {};
};

export const MultiTenantContextContainer = (props: { children: ReactNode }): JSX.Element => {
    const [state, setState] = useState<{ tenantId: string; tenantName: string; datavanter: boolean }>(
        getMultiTenantContextInitialState
    );

    useEffect(() => {
        if (typeof window !== 'undefined') window.localStorage.setItem('multiTenant', JSON.stringify(state));
    }, [state]);

    return (
        <MultiTenantContext.Provider
            value={{
                tenantId: state.tenantId,
                tenantName: state.tenantName,
                datavanter: state.datavanter,
                // @ts-expect-error - TS2322 - Type 'Dispatch<SetStateAction<{ tenantId: string; tenantName: string; datavanter: boolean; }>>' is not assignable to type '(value: { tenantId: string | undefined; tenantName: string | undefined; datavanter: boolean; }) => void'.
                setValue: setState,
            }}
        >
            {props.children}
        </MultiTenantContext.Provider>
    );
};
